<template>
  <v-card class="add-notes-container">
    <v-toolbar flat color="#fff" class="title-toolbar">
      <v-toolbar-title class="body-2">
        <span class="title">Add Notes</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="hideDialog">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text v-if="showSecond" style="background-color: #F9FAFD; height: 466px; padding: 0 16px 24px !important; line-height: 0px;">
      <v-row>
        <v-col cols="6">
          <div style="padding: 32px 8px 48px;"><p class="tips">Choose the specific button for the scenario that is applicable to their calls.</p></div>
          <div style="height: 366px; overflow-y: auto;">
            <div v-for="(itemArray, indexA) in secondContainer" :key="indexA">
              <template v-for="(item, index) in itemArray">
                <div :key="index + indexA * 2" class="second-box"><div @click="showThirdList(index + indexA * 2), clickItem(index + indexA * 2)" :class="{active:chooseIndex==index + indexA * 2}" class="show-text">{{ item.subject }}</div></div>
              </template>
              <br/>
            </div>
          </div>
        </v-col>
        <v-col cols="6" style="padding-left: 4px;">
          <v-textarea
            placeholder="Description"
            outlined
            v-model="notes"
            hide-details
            class="show-choosed-item"
            rows="14"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text v-else-if="showThird" style="background-color: #F9FAFD; height: 466px; padding: 0 16px 24px !important; line-height: 0px;">
      <v-row>
        <v-col cols="6">
          <div style="padding: 32px 8px 48px;"><p class="tips">Choose the specific button for the scenario that is applicable to their calls.</p></div>
          <div style="height: 366px; overflow-y: auto;">
            <div v-for="(itemArray, indexA) in thirdContainer" :key="indexA">
              <template v-for="(item, index) in itemArray">
                <div :key="index + indexA * 2" class="third-box"><div @click="showChoosedItem(index + indexA * 2), clickItem(index + indexA * 2)" :class="{active:chooseIndex==index + indexA * 2}" class="show-text-more">{{ item.subject }}</div></div>
              </template>
              <br/>
            </div>
          </div>
        </v-col>
        <v-col cols="6">
          <v-textarea
            placeholder="Description"
            outlined
            v-model="notes"
            hide-details
            class="show-choosed-item"
            rows="14"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text v-else-if="showChoosed" style="background-color: #F9FAFD; height: 466px; padding: 0 16px 24px !important; line-height: 0px;">
      <v-row>
        <v-col cols="6">
          <div style="padding: 32px 8px 48px;"><p class="tips">Choose the specific button for the scenario that is applicable to their calls.</p></div>
          <div style="height: 366px; overflow-y: auto;">
            <div v-for="(itemArray, indexA) in thirdContainer" :key="indexA">
              <template v-for="(item, index) in itemArray">
                <div :key="index + indexA * 2" class="third-box"><div @click="clickItem(index + indexA * 2)" :class="{active:chooseIndex==index + indexA * 2}" class="show-text-more">{{ item.subject }}</div></div>
              </template>
              <br/>
            </div>
          </div>
        </v-col>
        <v-col cols="6">
          <v-textarea
            placeholder="Description"
            outlined
            v-model="notes"
            hide-details
            class="show-choosed-item"
            rows="14"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text v-else style="background-color: #F9FAFD; height: 466px; padding: 0 16px 24px !important; line-height: 0px;">
      <v-row>
        <v-col cols="6">
          <div style="padding: 32px 8px 48px;"><p class="tips">Tips: Please select...</p></div>
          <div style="height: 366px; overflow-y: auto;">
            <div v-for="(itemArray, indexA) in firstContainer" :key="indexA">
              <template v-for="(item, index) in itemArray">
                <div :key="index + indexA * 2" class="first-box"><div @click="showSecondList(index + indexA * 2), clickItem(index + indexA * 2)" :class="{active:chooseIndex==index + indexA * 2}" class="show-text-first">{{ item.subject }}</div></div>
              </template>
              <br/>
            </div>
          </div>
        </v-col>
        <v-col cols="6">
          <v-textarea
            placeholder="Description"
            outlined
            v-model="notes"
            hide-details
            class="show-choosed-item"
            rows="14"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions style="background-color: #F9FAFD;">
      <v-btn @click="back" class="back-btn">Back</v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="saveNote" class="save-btn">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { Tool, Popup } from '@/util/index'
import { LoanOperationApi, NoteTemplateApi, OrganizationApi, OriginationApi } from '@/api/pandaria'
import { _ } from 'vue-underscore'

const tool = new Tool()
const popup = new Popup()

export default {
  name: 'add-notes-dialog',
  props: {
    loan: Object
  },
  data () {
    return {
      notes: '',
      showSaveBtn: false,
      showSecond: false,
      showThird: false,
      showChoosed: false,
      firstList: [],
      secondList: [],
      thirdList: [],
      chooseIndex: null,
      firstContainer: [],
      secondContainer: [],
      thirdContainer: [],
      companyId: 1,
      showTemplate: false,
      siteList: [],
      dialCount: {}
    }
  },
  watch: {
    notes (val) {
      if (this.showTemplate && tool.isNotEmpty(val)) {
        const target = {
          loan: this.store.getters.getLoan,
          account: this.store.getters.getAccount,
          customer: this.store.getters.getLoan
        }
        target.account.fullName = tool.getFullName(this.store.getters.getAccount)
        target.account.abbrName = this.getAbbrName(this.store.getters.getAccount.siteId, this.siteList)
        target.loan.dialCount = this.dialCount.dialTotalCount
        target.customer.phoneNumber = this.store.getters.getLoan.cellPhone
        // target.customer.location = tool.fieldRender(this.store.getters.getLoan, '{address}, {city}, {state}, {zip}', null, null, 'PROPER_CASE')
        this.notes = _.template(val)({ data: target })
        // this.notes = val
        //   .replace(/<%= data.account.fullName %>/g, tool.getFullName(this.store.getters.getAccount))
        //   .replace(/<%= data.account.abbrName %>/g, this.getAbbrName(this.store.getters.getAccount.siteId, this.siteList))
        //   .replace(/<%= data.loan.dialCount %>/g, this.dialCount.dialTotalCount)
        //   .replace(/<%= data.customer.phoneNumber %>/g, this.store.getters.getLoan.cellPhone)
        //   .replace(/<%= data.customer.location %>/g, tool.fieldRender(this.store.getters.getLoan, '{address}, {city}, {state}, {zip}', null, null, 'PROPER_CASE'))
      }
    }
  },
  async mounted () {
    await this.initNoteTemplate()
    await this.initSiteList()
    await this.getDialCount(this.store.getters.getLoan.id)
  },
  methods: {
    getDialCount (loanId) {
      const _this = this
      OriginationApi.getDialData(
        loanId,
        function (result) {
          const countData = result
          if (tool.isNotEmpty(countData)) {
            const dialDailyCount = countData.dialDailyCount
            const dialTotalCount = countData.dialTotalCount
            _this.dialCount = {
              dialDailyCount: tool.isNotEmpty(dialDailyCount) ? dialDailyCount : 0,
              dialTotalCount: tool.isNotEmpty(dialTotalCount) ? dialTotalCount : 0
            }
          }
        },
        function (err) {
          console.error(err)
          _this.$popWarningAlert({ text: tool.isEmpty(err.message) ? 'Failure' : err.message })
        }
      )
    },
    getAbbrName (id, list) {
      if (tool.isEmpty(list.find(ele => ele.id === id))) {
        return ''
      } else {
        return list.find(ele => ele.id === id).abbrName ? list.find(ele => ele.id === id).abbrName : ''
      }
    },
    initSiteList () {
      const input = {
        companyId: this.companyId
      }
      const _this = this
      OrganizationApi.getSiteList(
        input,
        function (result) {
          _this.siteList = result
        },
        function (err) {
          console.error(err)
          _this.$popWarningAlert({ text: tool.isEmpty(err.message) ? 'Failure' : err.message })
        }
      )
    },
    initNoteTemplate () {
      const input = {
        companyId: this.companyId
      }
      const _this = this
      NoteTemplateApi.getNoteTemplateList(
        input,
        function (result) {
          _this.firstList = result
          _this.firstContainer = _this.itemGroup(_this.firstList)
        },
        function (err) {
          console.error(err)
          _this.$popWarningAlert({ text: tool.isEmpty(err.message) ? 'Failure' : err.message })
        }
      )
    },
    itemGroup (list) {
      const count = Math.ceil(list.length / 2)
      const container = []
      container.length = count
      var i = 0
      var k = 0
      for (i; i < count; i++) {
        container[i] = []
        if (list.length < 3) {
          list.map(function (value) {
            container[i].push(value)
          })
        } else {
          for (k; k < list.length; k++) {
            if (k < 2 * (i + 1) && k > 2 * i - 1) {
              container[i].push(list[k])
            } else {
              break
            }
          }
        }
      }
      return container
    },
    saveNote () {
      const _this = this
      if (tool.isEmpty(_this.notes)) {
        popup.popupForWarning('Please enter note content')
      } else {
        LoanOperationApi.addNote(
          {
            loanId: _this.loan.id,
            noteContent: _this.notes
          },
          function () {
            popup.popupForSuccess('Success to add note')
          },
          function () {
            popup.popupForError('Failure to add note')
          }
        )

        _this.hideDialog()
        this.notes = ''
        this.showSaveBtn = false
        this.showSecond = false
        this.showThird = false
        this.showChoosed = false
      }
    },
    hideDialog () {
      this.$emit('hideDialog', 'ADD_NOTES')
      this.notes = ''
      this.showTemplate = false
      this.showSaveBtn = false
      this.showSecond = false
      this.showThird = false
      this.showChoosed = false
    },
    back () {
      if (this.showSecond === true) {
        if (this.showTemplate) {
          this.showTemplate = false
          this.showSaveBtn = false
          this.chooseIndex = null
        } else {
          this.showSecond = false
          this.showTemplate = false
          this.showSaveBtn = false
          this.chooseIndex = null
        }
      } else if (this.showThird === true) {
        if (this.showTemplate) {
          this.showTemplate = false
          this.showSaveBtn = false
          this.chooseIndex = null
        } else {
          this.showThird = false
          this.showSecond = true
          this.showTemplate = false
          this.showSaveBtn = false
          this.chooseIndex = null
        }
      } else if (this.showChoosed === true) {
        this.showChoosed = false
        this.showTemplate = false
        this.showSaveBtn = false
        this.showThird = true
        this.chooseIndex = null
      } else {
        this.showTemplate = false
        this.showSaveBtn = false
        this.chooseIndex = null
      }
    },
    showSecondList (index) {
      if (this.firstList[index].children === undefined) {
        this.secondList = []
        this.showTemplate = true
        this.showSaveBtn = true
        this.notes = this.firstList[index].template
      } else {
        this.secondList = this.firstList[index].children
        this.showSecond = true
        this.secondContainer = this.itemGroup(this.secondList)
        this.showTemplate = false
        this.showSaveBtn = false
      }
    },
    showThirdList (index) {
      if (this.secondList[index].children === undefined) {
        this.thirdList = []
        this.showTemplate = true
        this.showSaveBtn = true
        this.notes = this.secondList[index].template
      } else {
        this.thirdList = this.secondList[index].children
        this.showThird = true
        this.showSecond = false
        this.thirdContainer = this.itemGroup(this.thirdList)
        this.showTemplate = false
        this.showSaveBtn = false
      }
    },
    showChoosedItem (index) {
      this.showChoosed = true
      this.showThird = false
      this.showTemplate = true
      this.showSecond = false
      this.showSaveBtn = true
      this.chooseIndex = index
      this.notes = this.thirdList[index].template
    },
    clickItem (index) {
      this.chooseIndex = index
      if (!this.showTemplate) {
        this.chooseIndex = null
      } else {
        if (this.showSecond === true) {
          if (this.secondList[index].template !== undefined) {
            this.notes = this.secondList[index].template
          } else {
            this.notes = ''
          }
        } else if (this.showThird === true || this.showChoosed === true) {
          if (this.thirdList[index].template !== undefined) {
            this.notes = this.thirdList[index].template
          } else {
            this.notes = ''
          }
        } else {
          if (this.firstList[index].template !== undefined) {
            this.notes = this.firstList[index].template
          } else {
            this.notes = ''
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.add-notes-container {
  border-radius: 16px;
  // box-shadow: 0px 30px 60px 0px rgba(111, 122, 161, 0.2);
  box-shadow: 60px rgba(111, 122, 161, 0.2);
}
.title {
  color: #161A40 !important;
  font-size: 18px !important;
  font-weight: 600;
  height: 24px;
  line-height: 24px;
  font-family: 'Montserrat' !important;
}
.tips {
  color: #161A40 !important;
  font-size: 16px !important;
  font-weight: 600;
  height: 20px;
  line-height: 20px;
  font-family: 'Montserrat' !important;
  margin: 0;
}
.back-btn {
  text-transform: none;
  width: 62px;
  height: 32px !important;
  border-radius: 2px;
  box-shadow: none;
  background: #F2F5FD;
  color: #5C82E3;
  font-size: 12px !important;
  font-weight: 600;
  height: 16px;
  line-height: 16px;
  font-family: 'Montserrat' !important;
}
.save-btn {
  text-transform: none;
  width: 62px;
  height: 32px !important;
  border-radius: 2px;
  background: #5C82E3 !important;
  color: #fff;
  font-size: 12px !important;
  font-weight: 600;
  height: 16px;
  line-height: 16px;
  font-family: 'Montserrat' !important;
  box-shadow: 0px 4px 8px 0px rgba(101, 133, 216, 0.2);
  margin-right: 0;
}
.first-box {
  display: table-cell;
  width: 216px;
  height: 160px;
  padding: 8px;
  background: #F9FAFD;
}
.show-text-first {
  display: table-cell;
  width: 200px;
  height: 160px;
  padding: 8px;
  background: #E8EBF5;
  border-radius: 8px;
  color: #7E829B;
  opacity: 0.5;
  font-size: 16px !important;
  font-weight: normal;
  line-height: 20px;
  vertical-align: middle;
  font-family: 'Montserrat' !important;
  text-align: center;
}
.first-box.active {
  display: table-cell;
  padding: 8px;
  width: 216px;
  height: 160px;
  background: #F9FAFD;
}
.show-text-first.active {
  display: table-cell;
  width: 200px;
  height: 160px;
  padding: 8px;
  background: #E8EBF5;
  border-radius: 8px;
  opacity: 0.5;
  font-size: 16px !important;
  font-weight: normal;
  line-height: 20px;
  vertical-align: middle;
  font-family: 'Montserrat' !important;
  text-align: center;
  color: #5C82E3;
  border: 1px solid #5C82E3;
}
.second-box {
  display: table-cell;
  width: 216px;
  height: 160px;
  padding: 8px;
  background: #F9FAFD;
}
.show-text {
  display: table-cell;
  width: 200px;
  height: 160px;
  padding: 8px;
  background: #E8EBF5;
  border-radius: 8px;
  color: #7E829B;
  opacity: 0.5;
  font-size: 14px !important;
  font-weight: normal;
  line-height: 18px;
  vertical-align: middle;
  font-family: 'Montserrat' !important;
  text-align: center;
}
.second-box.active {
  display: table-cell;
  padding: 8px;
  width: 216px;
  height: 160px;
  background: #F9FAFD;
}
.show-text.active {
  display: table-cell;
  width: 200px;
  height: 160px;
  padding: 8px;
  background: #E8EBF5;
  border-radius: 8px;
  opacity: 0.5;
  font-size: 14px !important;
  font-weight: normal;
  line-height: 18px;
  vertical-align: middle;
  font-family: 'Montserrat' !important;
  text-align: center;
  color: #5C82E3;
  border: 1px solid #5C82E3;
}
.third-box {
  display: table-cell;
  padding: 0 8px 8px;
  width: 216px;
  height: 80px;
  background: #F9FAFD;
}
.show-text-more {
  display: table-cell;
  width: 200px;
  height: 80px;
  padding: 8px;
  background: #E8EBF5;
  border-radius: 8px;
  color: #7E829B;
  opacity: 0.5;
  font-size: 14px !important;
  font-weight: normal;
  line-height: 18px;
  vertical-align: middle;
  font-family: 'Montserrat' !important;
  text-align: center;
}
.third-box.active {
  display: table-cell;
  padding: 0 8px 8px;
  width: 216px;
  height: 80px;
  background: #F9FAFD;
}
.show-text-more.active {
  display: table-cell;
  width: 200px;
  height: 80px;
  padding: 8px;
  background: #E8EBF5;
  border-radius: 8px;
  opacity: 0.5;
  font-size: 14px !important;
  font-weight: normal;
  line-height: 18px;
  vertical-align: middle;
  font-family: 'Montserrat' !important;
  text-align: center;
  color: #5C82E3;
  border: 1px solid #5C82E3;
}
.show-choosed-item {
  // width: 848px;
  margin: 32px 8px 0 0;
  // height: 102px;
  // position: absolute;
  // bottom: 104px;
  // left: 24px;
  // border: 1px solid #E8EBF5;
}
</style>
<style lang="scss">
.title-toolbar .v-toolbar__content {
  padding: 24px;
  height: 72px !important;
  // box-shadow: 0px 4px 8px 0px rgba(191, 206, 222, 0.1);
  box-shadow: 8px rgba(191, 206, 222, 0.1);
}
.add-notes-container > .v-card__actions {
  padding: 24px !important;
}
.show-choosed-item.theme--light.v-input textarea {
  color: #7E829B;
  font-size: 14px;
  font-weight: 400;
  font-family: 'Montserrat' !important;
}
.show-choosed-item.v-textarea.v-text-field--enclosed.v-text-field--outlined:not(.v-input--dense) textarea {
  margin: 10px 0;
}
.show-choosed-item.v-text-field--outlined, .v-text-field--solo {
  border-radius: 8px;
  outline-color: none;
}
.show-choosed-item.primary--text {
  color: #5C82E3 !important;
  caret-color: #5C82E3;
}
</style>
